import React, { useEffect } from "react";
import MyRouter from "routers/index";
import { useDispatch } from "react-redux";
import { logoutUser, userActions } from "store/user";
import { getMeData } from "utils/requests/getRequest";
import { setUpCart } from "store/cartSlice";
import { AppDispatch } from "store";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './utils/theme';

function App() {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    const requestSubscription = async () => {
      const token = localStorage.getItem("access_token");
      const user = await getMeData(token);
      if (user?.subscriptions?.length && user?.subscriptions?.[0]?.id) {
        dispatch(userActions.subscription(user.subscriptions[0]));
        dispatch(
          userActions.subscriptionStatus(user?.user?.subscription_status)
        );
      }
    };
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser && loggedInUser !== "undefined") {
      const foundUser = JSON.parse(loggedInUser);

      const last_login_date = foundUser?.signed_in
        ? new Date(foundUser?.signed_in)
        : undefined;

      if (!last_login_date) {
        dispatch(logoutUser());
        return;
      }
      // const expires_in =
      //   localStorage.getItem("expires_in") === "24h"
      //     ? 24 * 60 * 60 * 1000
      //     : 24 * 60 * 60 * 1000;
      const now = new Date();
      // Calculate the difference in milliseconds
      const differenceInMilliseconds =
        now.getTime() - last_login_date.getTime();
      // Convert the difference to hours
      const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);

      // const twentyFourHoursAgo = new Date(now.getTime() - expires_in);
      // console.log(last_login_date);
      // console.log(twentyFourHoursAgo);
      if (differenceInHours >= 24) {
        dispatch(logoutUser());
      } else {
        const foundUser = JSON.parse(loggedInUser);
        dispatch(userActions.login());
        dispatch(userActions.user(foundUser));
        requestSubscription();
        dispatch(setUpCart());
      }
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
        <MyRouter />
      </div>
    </ThemeProvider>
  );
}

export default App;
